/**
 * Resolves the Azure Functions licman instance key (sent as the `licman` header).
 * Uses VITE_LICMAN_KEY or legacy REACT_APP_LICMAN_KEY from import.meta.env (see vite.config.js envPrefix).
 * Otherwise derives from window.location.hostname so one image can target dev/staging/prod UI hosts.
 *
 * @returns {string} One of dev-licman, staging-licman, live-licman (or a custom build-time value).
 */
function resolveLicmanKey() {
    const fromEnv =
        import.meta.env.VITE_LICMAN_KEY ||
        import.meta.env.REACT_APP_LICMAN_KEY ||
        window._env_?.REACT_APP_LICMAN_KEY ||
        "";
    if (fromEnv.trim() !== "") {
        return fromEnv.trim();
    }

    if (typeof window !== "undefined" && window.location?.hostname) {
        const host = window.location.hostname.toLowerCase();
        if (host.startsWith("staging.")) {
            return "staging-licman";
        }
        if (host.startsWith("dev.")) {
            return "dev-licman";
        }
        if (host === "licman.foodgenius.ai") {
            return "live-licman";
        }
    }

    return import.meta.env.DEV ? "dev-licman" : "staging-licman";
}

function getApiUrl() {
    if (typeof window !== "undefined" && window.location?.hostname) {
        const host = window.location.hostname.toLowerCase();
        if (host.startsWith("staging.")) {
            return "https://functions.foodgenius.ai/v1-staging";
        }
        if (host.startsWith("dev.")) {
            return "https://functions.foodgenius.ai/v1-dev";
        }
    }

    if (import.meta.env.DEV) {
        return import.meta.env.VITE_FUNCTIONS_URL || "https://functions.foodgenius.ai/v1-dev";
    }
    return "https://functions.foodgenius.ai/v1-staging";
}

class Config {
    constructor() {
        const isDev = import.meta.env.DEV;

        // License server (.NET): override with VITE_API_URL in .env.development (Vite exposes only VITE_* to the client).
        this.backendHost = isDev ? import.meta.env.VITE_API_URL || "http://localhost:44369" : "/b";
        this.currencyFormat = "0[.]00 $";
        this.grammagesFormat = "0[.]00";
        this.imageStorageBlobURL = "https://ggbiosmedia.blob.core.windows.net/ggbiosmedia/";

        // Functions base URL: VITE_* (local dev), REACT_APP_* (Helm/K8s via entrypoint env-config.js).
        this.apiUrl =
            import.meta.env.VITE_FUNCTIONS_URL ||
            import.meta.env.REACT_APP_FUNCTIONS_URL ||
            window._env_?.REACT_APP_FUNCTIONS_URL ||
            "https://functions.foodgenius.ai/v1-staging";
        // (isDev ? "https://functions.foodgenius.ai/v1-dev" : "https://functions.foodgenius.ai/v1");

        this.coreModule = "core";
        this.licmanModule = "licman";
        this.licmanKey = resolveLicmanKey();
    }
}

export default Config;
